<template>
  <v-form @submit.prevent="onSubmit" ref="form">
    <v-row>
      <v-col cols="12" v-for="(item, i) in resource.items" :key="'item-'+i">
        <v-row>
          <v-col cols="12" md="4" class="py-0">
            <v-text-field v-model="item.title_en" outlined dense :label="i18n['po_item_title_en']"
              :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required]" />
          </v-col>
          <v-col cols="12" md="4" class="py-0">
            <v-text-field v-model="item.title_ar" outlined dense :label="i18n['po_item_title_ar']"
              :class="`${arabic ? 'arFont' : 'enFont'}`" />
          </v-col>
          
          <v-col cols="12" md="4" class="py-0">
            <v-textarea v-model="item.description" outlined dense :label="i18n['po_item_description']"
              :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required]" />
          </v-col>
          <v-col cols="12" md="4" class="py-0">
            <v-text-field type="number" v-model="item.quantity" outlined dense :label="i18n['po_item_quantity']"
              :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required]" />
          </v-col>
          <v-col cols="12" md="4" class="py-0">
            <v-text-field type="number" v-model="item.price" outlined dense :label="i18n['po_item_price']"
              :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required, rules.minValue]" />

          </v-col>
          <v-col cols="12" md="4" class="py-0">
            <Field :field="imageField" :item="item" :index="i" @getUpload="getUpload" />
          </v-col>
          <v-col cols="12" md="4" class="py-0">
            <v-text-field v-model="item.source_url" outlined dense :label="i18n['po_item_source_url']"
              :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required]" />
          </v-col>
          <v-col cols="12" md="4" class="py-0">
            <v-text-field v-model="item.origin" outlined dense :label="i18n['origin']"
              :class="`${arabic ? 'arFont' : 'enFont'}`" :rules="[rules.required]" />


          </v-col>
          
          <v-col cols="12" md="4" class="py-0">
            <Field :field="countryField" :item="item" />
          </v-col>
          
          <v-col cols="12" md="4" class="py-0">
            <v-textarea v-model="item.note" outlined dense :label="i18n['note']"
              :class="`${arabic ? 'arFont' : 'enFont'}`" />
          </v-col>
          
          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
            <v-btn type="submit" color="success" v-if="resource.id">{{ i18n["update"] }}</v-btn>
            <v-btn type="submit" color="success" v-else>{{ i18n["po_submit"] }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Field from '@/components/Field.vue';
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
    Field,
  },
  props: ['resource', 'countries'],
  data() {
    return {
      imageField: {
        name: "image",
        type: 'upload',
        label: 'image',
        info: { en: '', ar: '' }
      },
      countryField: {
        name: "destination",
        label: 'destination',
        returnValue:'value',
        type: 'select',
        required:true,
        info: { en: '', ar: '' },
        data:[...this.$props.countries]
      },
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email'],
        url: value => /^(?:(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,})|(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}))(?:\/[^\s]*)?$/.test(value) || this.i18n['required'],
        minValue: value => value >= 1 || 'Value must be greater than or equal to 1.',

      },
    }
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar")
        return true;
    },
    
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('onSubmit')
      }
    },
    getUpload(image) {
      console.log(image)
      this.resource.items[image.index].image = image.value
      
    },
    async addNewServicePage() {
      if (this.$refs.form.validate()) {
        this.loading = true
        console.log(this.resouce)
        // await this.$store.dispatch('putResource', { resource: `/purchase-orders/${this.resource.id}`, value: this.resource })
        this.loading = false

        // this.$router.push('/purchase-orders')
      }
    }
  },
}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
</style>